module.exports = __webpack_public_path__ + "static/media/image_7.ca8653f3.png";